import moment from "moment";

export const format = (amount) => parseFloat(amount).toFixed(2);

export const ziplineFee = (price, fixedFee, variableFee) => {
  return format((price * variableFee) + fixedFee);
};

export const influencerFee = (price, commission, isPercentage) => {
  return (
    commission && format(isPercentage ? (commission / 100) * price : commission)
  );
};

export const totalPrice = (price, commission, isPercentage, fixedFee, variableFee) => {
  return (
    commission &&
    format(
      price - ziplineFee(price, fixedFee, variableFee) - influencerFee(price, commission, isPercentage)
    )
  );
};

const getDefaultMaxDate = () => {
  var date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  return date;
};

const getDefaultMinDate = () => {
  var date = new Date();
  date.setFullYear(date.getFullYear() - 1);
  return date;
};

export const dateInputProps = ({
  format,
  minDate = getDefaultMinDate(),
  maxDate = getDefaultMaxDate(),
  value
}) => {
  const isDateInRange = (str, format) => {
    let min = moment(minDate).subtract(1, "day");
    let max = moment(maxDate).add(1, "day");
    return (
      moment(str, format).isBefore(max) && moment(str, format).isAfter(min)
    );
  };

  const parseDate = (str) => {
    return moment(str, format).isValid() && isDateInRange(str, format)
      ? moment(str, format).toDate()
      : null;
  };

  return {
    parseDate,
    formatDate: (date) => moment(date).format(format),
    minDate,
    maxDate,
    plcaHolder: format,
    value: moment(value, format).toDate()
  };
};
